import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import color from '../../../config/colors.json';

const inputStyle = css`
    border: 1px solid ${color.lightGrey3};
    padding: ${({ padding }) => (padding || '')};
    color: ${color.dark};
    font-family: 'Poppins', sans-serif;
    font-size: ${({ fontSize }) => (fontSize || '')};
    line-height: ${({ lineheight }) => (lineheight || '18px')};
    border-radius: ${({ borderradius }) => borderradius};
    width: 100%;
    appearance: none;
    &::placeholder {
        font-family: 'Poppins', sans-serif;
        color: ${color.lightGrey3};
    }
    ${({ theme }) => theme === 'light' && `
        border: 0;
        border-bottom: 1px solid ${color.lightGrey9}
    `}
    ${({ theme }) => theme === 'light-bold' && `
        padding: 0;
        border: 0;
        border-bottom: 1px solid ${color.lightGrey9}
        font-size: 17px;
        line-height: 26px;
        color: ${color.darkGrey41}
        &::placeholder {
            font-family: 'Poppins', sans-serif;
            color: ${color.darkGrey41};
        }
    `}
    &:focus {
        outline: 0;
    }
`;

export const Input = styled.input`
    ${inputStyle};
`;

export const Select = styled.select`
        ${inputStyle};
        background-color: transparent;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="${color.darkGrey2.replace('#', '%23')}" viewBox="0 0 490.677 490.677"><path d="M489.272 37.339a10.695 10.695 0 00-9.259-5.333H10.68a10.697 10.697 0 00-9.259 5.333 10.648 10.648 0 00.021 10.667l234.667 405.333c1.899 3.307 5.419 5.333 9.237 5.333s7.339-2.027 9.237-5.333L489.251 48.005c1.898-3.285 1.898-7.36.021-10.666z"/></svg>');
        background-size: 10px;
        background-position: calc(100% - 8px) center;
        background-repeat: no-repeat;
    `;

export const NumberInput = styled(NumberFormat)`
    ${inputStyle};
`;

const defaultPropTypes = {
    padding: '4px 15px',
    fontSize: '12px',
    lineheight: '18px',
    borderradius: '0px',
};

const styledPropTypes = {
    padding: PropTypes.string,
    fontSize: PropTypes.string,
    lineheight: PropTypes.string,
    borderradius: PropTypes.string,
};

inputStyle.defaultProps = {
    ...defaultPropTypes,
};

PropTypes.inputStyle = {
    ...styledPropTypes,
};

Input.defaultProps = {
    ...defaultPropTypes,
};

PropTypes.Input = {
    ...styledPropTypes,
};

NumberInput.defaultProps = {
    ...defaultPropTypes,
};

PropTypes.NumberInput = {
    ...styledPropTypes,
};
